var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-reports"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reports",
    clipPath: "url(#clip-reports)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(-43.062 -567.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(46.063 567.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_218",
    "data-name": "Path 218",
    transform: "translate(-46.063 -567.3)",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.241,567.3H51.063a5,5,0,0,0-5,5v30a5,5,0,0,0,5,5h23.28a5.068,5.068,0,0,0,5.053-5.051v-21.8a3.592,3.592,0,0,0-1.053-2.538l-9.562-9.564A3.59,3.59,0,0,0,66.241,567.3Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 51.06295776367188 569.800048828125 C 49.68447875976562 569.800048828125 48.56300354003906 570.9215087890625 48.56300354003906 572.2999267578125 L 48.56300354003906 602.2996826171875 C 48.56300354003906 603.6781616210938 49.68447875976562 604.7996826171875 51.06295776367188 604.7996826171875 L 74.34275817871094 604.7996826171875 C 75.01884460449219 604.7996826171875 75.65847015380859 604.5325317382812 76.143798828125 604.0474853515625 C 76.62888336181641 603.5626831054688 76.89602661132812 602.923828125 76.89602661132812 602.24853515625 L 76.89602661132812 580.4532470703125 C 76.89602661132812 580.16796875 76.77899169921875 579.8873291015625 76.57476043701172 579.68310546875 L 67.01263427734375 570.1187744140625 C 66.80713653564453 569.9132690429688 66.53294372558594 569.800048828125 66.2406005859375 569.800048828125 L 51.06295776367188 569.800048828125 M 51.06295776367188 567.300048828125 L 66.2406005859375 567.300048828125 C 67.19392395019531 567.300048828125 68.10725402832031 567.677734375 68.78057861328125 568.3511962890625 L 78.34272766113281 577.91552734375 C 79.01603698730469 578.5888671875 79.39602661132812 579.502197265625 79.39602661132812 580.4532470703125 L 79.39602661132812 602.24853515625 C 79.39602661132812 605.0263671875 77.12051391601562 607.2996826171875 74.34275817871094 607.2996826171875 L 51.06295776367188 607.2996826171875 C 48.30077362060547 607.2996826171875 46.06300354003906 605.06201171875 46.06300354003906 602.2996826171875 L 46.06300354003906 572.2999267578125 C 46.06300354003906 569.537841796875 48.30077362060547 567.300048828125 51.06295776367188 567.300048828125 Z",
    stroke: "none",
    fill: "#5c6d7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(7.777 20.666)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_711",
    "data-name": "Rectangle 711",
    width: 17.778,
    height: 2.222,
    rx: 1,
    fill: "#5c6d7e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_712",
    "data-name": "Rectangle 712",
    width: 17.778,
    height: 2.222,
    rx: 1,
    transform: "translate(0 6.667)",
    fill: "#5c6d7e"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 3.333,
    cy: 3.333,
    r: 3.333,
    transform: "translate(8.332 8.444)",
    fill: "#5c6d7e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.a351c5e66cb5be93c9bad4d588de277b.svg";
export { ForwardRef as ReactComponent };